import React, { useMemo } from "react";
import { Paper, Stack, Text, Group } from "@mantine/core";
import { TumblingEMetrics } from "types/testTypes";
import { useTranslation } from "react-i18next";

export interface TumblingEMetricsCardProps {
  metrics?: TumblingEMetrics | null;
}

const TumblingEMetricsCard: React.FC<TumblingEMetricsCardProps> = ({ metrics }) => {
  const { t } = useTranslation();

  const rows = useMemo(() => {
    const baseRows = [
      { key: "totalStimuli", value: metrics?.totalStimuli },
      { key: "correctResponses", value: metrics?.correctResponses },
      { key: "incorrectResponses", value: metrics?.incorrectResponses },
      { key: "skippedResponses", value: metrics?.skippedResponses },
    ];

    const formatErrorRate = () => {
      const rate = metrics?.errorRate;
      if (typeof rate !== "number" || Number.isNaN(rate)) return "—";
      const normalized = rate > 1 ? rate : rate * 100;
      return `${normalized.toFixed(1)}%`;
    };

    return [
      ...baseRows.map(({ key, value }) => ({
        label: t(`TumblingE.metrics.${key}`),
        value: value ?? "—",
      })),
      { label: t("TumblingE.metrics.errorRate"), value: formatErrorRate() },
    ];
  }, [metrics, t]);

  return (
    <Paper shadow="xs" radius="md" p="md" withBorder>
      <Stack gap="sm">
        <Text fw={600} size="md">
          {t("TumblingE.metrics.title")}
        </Text>
        <Stack gap={6}>
          {rows.map(({ label, value }) => (
            <Group key={label} justify="space-between" gap="xs">
              <Text size="sm" c="dimmed">
                {label}
              </Text>
              <Text size="sm" fw={600}>
                {value}
              </Text>
            </Group>
          ))}
        </Stack>
      </Stack>
    </Paper>
  );
};

export default TumblingEMetricsCard;
